// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/_css-loader@3.6.0@css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sidebar-container .horizontal-collapse-transition{transition:width 0s ease-in-out,padding-left 0s ease-in-out,padding-right 0s ease-in-out}.sidebar-container .scrollbar-wrapper{overflow-x:hidden!important}.sidebar-container .el-scrollbar__bar.is-vertical{right:0}.sidebar-container .el-scrollbar__bar.is-horizontal{display:none}.el-scrollbar__view{height:100%!important}", ""]);
// Exports
exports.locals = {
	"menuBg": "#414146",
	"menuText": "#e0e3da",
	"menuActiveText": "#fffff3"
};
module.exports = exports;
